import NestedForm from '/node_modules/stimulus-rails-nested-form/dist/stimulus-rails-nested-form.umd.js'
import axios from "axios";
import notify from "../../packs/notify";
import TestScheduleListManage from "../../packs/test_schedule_list_manage";
import LoadingSpinner from "../../packs/loading_spinner";
import i18next from 'i18next';

let testScheduleList = []

const autoCompleteHiddenSelector = "[data-portal--submission-test-target='autoCompleteHidden']"
const autoCompleteInputSelector = "[data-portal--submission-test-target='autoCompleteInput']"
const msHiddenSelector = "[data-portal--submission-test-target='msHidden']"
const testInfoContentSelector = "[data-portal--submission-test-target='testInfoContent']"

export default class extends NestedForm {

  static targets = [
    "testCard",
    "childNewIndexValue",
    "msHidden",
    "autoCompleteHidden",
    "stsIds",
    "testInfoContent",
    "allTestSchedule",
    "showAllTSInTheList",
    "autoCompleteInput"
  ]

  static values = {
    childIndex: { type: Number, default: 0 },
    recordSize:{ type: Number, default: 0 },
    addEventCounter: { type: Number, default: 0 },
    accessionId: String,
    animalId: String,
    accessionLabId: Number
  };

  connect() {
    super.wrapperSelectorValue = '.nested-form-test-wrapper'
    super.connect()
    this.childIndex = this.recordSizeValue - 1
    this.boundAddTestSchedule = this.addTestSchedule.bind(this)
    this.boundRemoveTestSchedule = this.removeTestSchedule.bind(this)
    this.boundChangeAutoComplete = this.changeAutoComplete.bind(this)
    this.boundRemoveItemFromAutoComplete = this.removeItemFromAutoComplete.bind(this)
    this.boundFindingMultipleRecord = this.findingMultipleRecord.bind(this)

    document.addEventListener("multiselect:triggerMultiselectAddEvent",this.boundAddTestSchedule)
    document.addEventListener("multiselect:triggerMultiselectRemoveEvent", this.boundRemoveTestSchedule)
    document.addEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundChangeAutoComplete )
    document.addEventListener("autocomplete:removeItemFromAutoCompleteData", this.boundRemoveItemFromAutoComplete)
    document.addEventListener("multiselect:triggerMultiselectHasAlreadyRecord",this.boundFindingMultipleRecord)

    testScheduleList = TestScheduleListManage(this.stsIdsTargets, "initial", "")
    this.checkInitalAllTSInTheListTarget()
    this.checkAccessionLab()
  }

  disconnect(){
    testScheduleList = []
    testScheduleList.length = 0
    TestScheduleListManage("", "removeMainList", "")
    document.removeEventListener("multiselect:triggerMultiselectAddEvent", this.boundAddTestSchedule)
    document.removeEventListener("multiselect:triggerMultiselectRemoveEvent", this.boundRemoveTestSchedule)
    document.removeEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundChangeAutoComplete )
    document.removeEventListener("autocomplete:removeItemFromAutoCompleteData", this.boundRemoveItemFromAutoComplete)
    document.removeEventListener("multiselect:triggerMultiselectHasAlreadyRecord",this.boundFindingMultipleRecord)
  }
  // https://dev.labs.tracefirst.com/portal/144336/add_test_schedule_to_specimens.json
  addTestSchedule(e, specimenValuesIds=""){
    const specimenIds =  specimenValuesIds ? specimenValuesIds : e.detail.item.value
    const testScheduleIdTarget = this.findTargetByQuerySelector(autoCompleteHiddenSelector, e)

    const testScheduleId = testScheduleIdTarget ? testScheduleIdTarget.value : ""
    if (!specimenIds || !testScheduleId || !this.accessionIdValue) {
      console.warn("There is no specimen ID or Test Schedule ID or Accession ID. You might deleted the existing test already or try re-select a Test again!");
      return
    }

    LoadingSpinner("show")
    const currentScheduleItems = TestScheduleListManage(specimenIds, "find", e)
    const currentStsIds = currentScheduleItems[0]
    if (currentStsIds && currentStsIds.length > 0) {
      let msg =  i18next.t('An error occurred when adding the Test Request')
      msg += " " + i18next.t('Seems you have already added these tests')
      notify({
        message: msg,
        status: "error"
      });
      LoadingSpinner("hide")
      return Promise.resolve()
    }

    const url = "/portal/" + this.accessionIdValue + "/add_test_schedule_to_specimens.json"
    const data = {
      specimen_ids: specimenIds,
      test_schedule_id: testScheduleId,
      id: this.accessionIdValue
    }
    return axios({ method: 'POST',  url: url, data: data })
    .then(res => {
      testScheduleList = TestScheduleListManage(res.data, "add", e)
      const selectedCard = e.target.closest(this.wrapperSelectorValue);
      selectedCard.dataset.newRecord = false
      this.availabilityForAnimal(testScheduleId, specimenIds)
      this.toggleDisabledAutoCompleteInput(e, true)
      LoadingSpinner("hide")
    })
    .catch((error) => {
      LoadingSpinner("hide")
      // const msg =  LocaleMessage('errorWhenAddingTestRequest')
      const msg =  i18next.t('An error occurred when adding the Test Request')
      notify({
        message: msg + " : " + error,
        status: "error"
      });
    });
  }

  // https://dev.labs.tracefirst.com/portal/delete_specimen_test_schedules.json
  // specimen_ids: 649962
  // specimen_test_schedule_ids[]: 1125532
  removeTestSchedule(e, specimenIdValues = ""){
    const specimenIds =  specimenIdValues ? specimenIdValues : e.detail.id
    const currentScheduleItems = TestScheduleListManage(specimenIds, "find", e)
    if (!currentScheduleItems){
      console.warn("There is no specimen test schedule. You might deleted the existing test already or try re-select a Test again!");
      return Promise.resolve()
    }

    const currentStsIds = currentScheduleItems[0]
    const currentSelectedObjects = currentScheduleItems[1]
    if (!specimenIds || !currentStsIds) {
      return Promise.resolve()
    }

    const url = "/portal/delete_specimen_test_schedules.json"
    const data = {
      specimen_ids: specimenIds,
      specimen_test_schedule_ids: currentStsIds
    }
    LoadingSpinner("show")
    return axios({ method: 'POST', url: url, data: data })
    .then(res => {
      testScheduleList = TestScheduleListManage(currentSelectedObjects, "remove", e)
      LoadingSpinner("hide")
      return res
    })
    .catch((error) => {
      LoadingSpinner("hide")
      // const msg = LocaleMessage('errorWhenDeletingTestRequest')
      const msg =  i18next.t('An error occurred when deleting the Test Request')
      notify({
        message: msg + " : " + error,
        status: "error"
      });
    });
  }

  findTargetByQuerySelector(selector, e){
    const dataId = e.target.dataset.id
    return document.querySelector(`${selector}[data-id="${dataId}"]`)
  }

  add(e){
    this.childIndex++
    super.add(e)
    let currentInfoTestContent = this.getLastTarget(this.testInfoContentTargets)
    if (currentInfoTestContent) currentInfoTestContent.innerHTML = ""
    this.updateLastNewIndexTarget()
    this.toggleForAllTestScheduleView()
  }

  updateLastNewIndexTarget(){
    let lastNewIndexTarget = this.getLastTarget(this.childNewIndexValueTargets)
    if (lastNewIndexTarget){
      lastNewIndexTarget.innerHTML = (this.childIndex + 1) + " - "
    }
  }

  getLastTarget(targets){
    return targets[targets.length - 1]
  }

  changeAutoComplete(e){
    const tsID = e.detail.event.detail.value
    if (!tsID) return
    this.fillTestInfoContent(e,this.testInfoTemplate(tsID))
    const selectedMSHidden = this.findTargetByQuerySelector(msHiddenSelector, e)
    const specimenIds = selectedMSHidden ? selectedMSHidden.values : ""
    if (!specimenIds || specimenIds.length == 0) return

    this.addTestSchedule(e, specimenIds.toString())
  }

  deleteTest(e){
    const selectedCard = e.target.closest(this.wrapperSelectorValue);
    if (selectedCard.dataset.newRecord === 'true'){
      super.remove(e)
      this.childIndex--
      this.toggleForAllTestScheduleView() 
    } else {
      const selectedMSHidden = this.findTargetByQuerySelector(msHiddenSelector, e)
      const specimenIds = selectedMSHidden ? selectedMSHidden.values : ""
      if (!specimenIds) return
    
      let deletedTs = this.removeTestSchedule(e, specimenIds.toString())
      if (!deletedTs){
        super.remove(e)
        this.childIndex--
        this.toggleForAllTestScheduleView()
      }
      deletedTs.then(res => {
        super.remove(e)
        this.childIndex--
        this.toggleForAllTestScheduleView()
      })
    }
  }

  removeItemFromAutoComplete(e){
    const tsID = e.detail.data.value
    const selectedMSHidden = this.findTargetByQuerySelector(msHiddenSelector, e)
    const specimenIds = selectedMSHidden ? selectedMSHidden.values : ""
    this.fillTestInfoContent(e, "")
    if (!specimenIds || specimenIds.length == 0) return

    this.removeTestSchedule(e, specimenIds.toString())
    .then(res => { 
      this.toggleDisabledAutoCompleteInput(e)
     })
  }

  fillTestInfoContent(e, data){
    const currentInfoTestContent = this.findTargetByQuerySelector(testInfoContentSelector, e)
    currentInfoTestContent.innerHTML = data
  }

  testInfoTemplate(tsID){
    return `<div class="relative" data-controller="popover" data-popover-url-value="/portal/test_info/`+tsID+`.html">
              <span data-action="mouseenter->popover#show mouseleave->popover#hide" style="cursor: pointer;">
                <i class="fa fa-info-circle"></i>
              </span>
            </div>`
  }

  // https://dev.labs.tracefirst.com/test_schedules/check_availability_for_animal?test_schedule_id=4208&animal_id=386556&specimen_id=651504
  availabilityForAnimal(tsId, specimenIds){   
    specimenIds = this.checkSpecimenIDS(specimenIds)
    for (let index = 0; index < specimenIds.length; index++) {
      const specimenId = specimenIds[index]
      this.axiosAvailabilityForAnimal(tsId, specimenId).then(res =>{
        if (!res.data){
          const msg = i18next.t('Requested test does not match species/breed of choosen animal')
          notify({
            message: msg,
            status: "alert"
          })
          return false
        }
      })
    }
  }

  checkSpecimenIDS(specimenIds){
    try {
      if (Array.isArray(specimenIds)){
        specimenIds = specimenIds[0].constructor == Array ? specimenIds[0] : specimenIds
      } else {
        if (specimenIds.indexOf(",") > -1){
          specimenIds = specimenIds.split(",")
        } else {
          specimenIds = [specimenIds]
        }
      }
    } catch (error) {
      console.warn("Error : ", error)
    }
    return specimenIds
  }

  async axiosAvailabilityForAnimal(tsId, specimenId){
    return axios({ 
      method: 'GET', 
      url: "/test_schedules/check_availability_for_animal.json",
      params: {
        test_schedule_id: tsId,
        specimen_id: specimenId,
      }
    })
    .then(res => {
      return res
    })
    .catch((error) => {
      const msg = i18next.t('An error occurred when matching species/breed of choosen animal')
      notify({
        message: msg + " : " + error,
        status: "error"
      });
    });
  }

  checkInitalAllTSInTheListTarget(){
    let target = this.showAllTSInTheListTarget
    target.hidden = this.recordSizeValue > 0 ? false : true
  }

  toggleForAllTestScheduleView(){
    let target = this.showAllTSInTheListTarget
    target.hidden = this.childIndex + 1 > 0 ? false : true
  }

  toggleDisabledAutoCompleteInput(e, isAdded = false){
    const currentACInput = this.findTargetByQuerySelector(autoCompleteInputSelector, e)
    if (isAdded){
      currentACInput.disabled = true
    } else {
      currentACInput.disabled = currentACInput.disabled ? false : true
    }
  }

  checkAccessionLab(){
    if (!this.accessionLabIdValue){
      const msg = i18next.t('Available tests are not able to be displayed until a Lab is chosen')
      notify({
        message: msg,
        status: "alert"
      });
    }
  }
  
  findingMultipleRecord(e){
    e.detail.dataset.text
    let msg =  i18next.t('An error occurred when adding the Test Request')
    msg += " " + i18next.t('Seems you have already added these tests')
    msg += " " + e.detail.dataset.text
    notify({
      message: msg,
      status: "error"
    });
  }
  
}